import { AuthenticationStore } from "@istari-frontend/auth";
import { IstariV3Client } from "@istari/istari-client";

import { invokeWithCurrentToken, refreshExpiredAccessToken } from "./client-invocation";
import { resolveRegistryTarget } from "./registry-target";

const getClientV3SDK = () => {
  const AS = AuthenticationStore();
  const registryAuthToken = AS.getAccessToken() || "";
  const target = resolveRegistryTarget();
  return target.kind === "gateway"
    ? new IstariV3Client({ digitalApiUrl: target.digitalApiUrl, registryAuthToken })
    : new IstariV3Client(target.registryUrl, registryAuthToken);
};

const clientV3SDK = new Proxy({} as IstariV3Client, {
  get(target, prop) {
    const client = getClientV3SDK();
    const value = client[prop as keyof IstariV3Client];

    if (typeof value === "function") {
      return async (...args: unknown[]) => {
        await refreshExpiredAccessToken();
        return await invokeWithCurrentToken(getClientV3SDK, prop as keyof IstariV3Client, args);
      };
    }

    return value;
  },
});

export default clientV3SDK;
